/**
 * OVERRIDE ContentMetadataTags.jsx
 */

import ContentMetadataTags from '../../../../components/ContentMetadataTags/ContentMetadataTags';

export default ContentMetadataTags;